import React from 'react';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error?.message, error?.stack, errorInfo?.componentStack);
  }

  handleDismiss = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError && this.state.error) {
      const msg = this.state.error?.message || 'Something went wrong';
      return (
        <div
          style={{
            padding: '2rem',
            maxWidth: '500px',
            margin: '2rem auto',
            textAlign: 'center',
            border: '1px solid #f0c0c0',
            borderRadius: '8px',
            backgroundColor: '#fff8f8',
          }}
        >
          <h3 style={{ color: '#c00', marginBottom: '0.5rem' }}>Something went wrong</h3>
          <p style={{ color: '#666', marginBottom: '1rem' }}>{msg}</p>
          <button
            type="button"
            onClick={this.handleDismiss}
            style={{
              padding: '8px 16px',
              background: '#D9A128',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Dismiss
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
